export const CREATE_EDITOR = 'CREATE_EDITOR';
export const SELECT_EDITOR = 'SELECT_EDITOR';
export const SELECT_TAB    = 'SELECT_TAB';
export const HIDE_EDITOR   = 'HIDE_EDITOR';
export const UPDATE_EDITOR = 'UPDATE_EDITOR';
export const RENAME_EDITOR = 'RENAME_EDITOR';
export const DELETE_EDITOR = 'DELETE_EDITOR';



/** WEBPACK FOOTER **
 ** ./app/constants/CodeMirrorActionTypes.js
 **/